import { render, staticRenderFns } from "./QueryNew.vue?vue&type=template&id=80fcf818&"
import script from "./QueryNew.vue?vue&type=script&lang=js&"
export * from "./QueryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports